var map = {
	"./collection-active.svg": "4981",
	"./collection-black.svg": "fbc9",
	"./collection-white.svg": "472b",
	"./icon-search.svg": "a63b",
	"./icon-user.svg": "5394",
	"./like-active.svg": "db74",
	"./like-black.svg": "b862",
	"./like-white.svg": "f65b",
	"./unlike-active.svg": "c2c0",
	"./unlike-black.svg": "5cad",
	"./unlike-white.svg": "e7e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a82a";